import { useState } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import Button from '../../layout/Button/Button'
import { useAuth } from '../../../hooks/AuthContext'
import { useToast } from '../../../hooks/Toast'
import { aceitarConvite } from '../../../firebase/hierarquia'

export default function AceitarConvite() {
  const { token } = useParams()
  const { usuario, carregando: carregandoAuth } = useAuth()
  const { mostrarAviso } = useToast()

  const [processando, setProcessando] = useState(false)
  const [resultado, setResultado] = useState(null) // { tipoAlvo, nomeEscolaPai }
  const [erro, setErro] = useState(null)

  if (carregandoAuth) return <p>Carregando...</p>

  // Precisa estar logado como diretor pra aceitar — manda pro login,
  // guardando a intenção de voltar aqui depois (o link continua na URL).
  if (!usuario) {
    return <Navigate to="/login" replace />
  }

  if (usuario.perfil !== 'adm') {
    return (
      <section style={{ padding: 16 }}>
        <h3>Vínculo entre escolas</h3>
        <p>Só o diretor da escola pode aceitar este convite. Peça pra ele abrir este link.</p>
      </section>
    )
  }

  const handleAceitar = async () => {
    setProcessando(true)
    setErro(null)
    try {
      const resposta = await aceitarConvite(usuario.idEscola, token)
      setResultado(resposta)
      mostrarAviso('Vínculo criado com sucesso', 'sucesso')
    } catch (error) {
      setErro(error.message)
      mostrarAviso('Erro ao aceitar convite: ' + error.message, 'erro')
    } finally {
      setProcessando(false)
    }
  }

  return (
    <section style={{ padding: 16, textAlign: 'center' }}>
      <h3>Vínculo entre escolas</h3>

      {!resultado && !erro && (
        <>
          <p>
            Você está prestes a vincular <strong>sua escola</strong> a outra
            instituição usando este link de convite. A partir disso, ela passa a poder ler os
            relatórios mensais da sua escola.
          </p>
          <Button onClick={handleAceitar} disabled={processando}>
            {processando ? 'Vinculando...' : 'Confirmar vínculo'}
          </Button>
        </>
      )}

      {resultado && (
        <p>
          Pronto! Sua escola agora está vinculada a <strong>{resultado.nomeEscolaPai}</strong> como{' '}
          {resultado.tipoAlvo === 'regional' ? 'Regional' : 'Geral'}.
        </p>
      )}

      {erro && <p style={{ color: '#b91c1c' }}>Não foi possível concluir: {erro}</p>}
    </section>
  )
}
